import { ColumnDef } from "@tanstack/react-table"

export interface ColumnInfo {
  header: string | undefined
  accessorKey?: string
  id?: string
  hasAccessorFn: boolean
  missingId: boolean
}

// Lista kolumninformation rekursivt
export function listColumnIds<T>(columns: ColumnDef<T>[]): ColumnInfo[] {
  const result: ColumnInfo[] = []

  function recurse(cols: ColumnDef<T>[]) {
    cols.forEach((col) => {
      const c = col as ColumnDef<T, any> & {
        accessorKey?: string
        accessorFn?: (row: T) => any
        columns?: ColumnDef<T>[]
      }

      const info: ColumnInfo = {
        header: typeof c.header === "string" ? c.header : undefined,
        accessorKey: c.accessorKey,
        id: c.id,
        hasAccessorFn: !!c.accessorFn,
        missingId: !!c.accessorFn && !c.id
      }

      result.push(info)

      if (c.columns) {
        recurse(c.columns)
      }
    })
  }

  recurse(columns)
  return result
}

// Håller endast senaste tabellen
let trackedTable: ColumnDef<any>[] | null = null

// Registrera tabellen
export function registerTable<T>(columns: ColumnDef<T>[]) {
  trackedTable = columns
}

// Logga tabellen snyggt i konsolen
export function logTableColumns() {
  if (!trackedTable) {
    return
  }

  const report = listColumnIds(trackedTable)
  console.log(`\n Tabell:`)
  console.table(report, ["header", "accessorKey", "id", "hasAccessorFn", "missingId"])
}

// Exponera funktionerna på window för konsolbruk
if (typeof window !== "undefined") {
  ;(window as any).logTableColumns = logTableColumns
}
